'use client';

import { InverseHeader } from '@jouzen/ecom-components';

import AppsThatIntegrate from './_components/AppsThatIntegrate';
import CallToAction from './_components/CallToAction';
import Hero from './_components/DeveloperHero';
import WaysToIntegrate from './_components/WaysToIntegrate';
import WhyUseApi from './_components/WhyUseApi';

const Content = (): JSX.Element => {
  return (
    <>
      <InverseHeader enter>
        <Hero />
      </InverseHeader>
      <WhyUseApi />
      <AppsThatIntegrate />
      <InverseHeader enter>
        <WaysToIntegrate />
      </InverseHeader>
      <CallToAction />
    </>
  );
};

export default Content;
